import $ from 'jquery'

const $doc = $(document)

function ajaxLoadMoreFeedPosts($button) {
  const $feed = $button.closest('.post-feed')
  const data = {
    page: $button.attr('data-page'),
    types: $button.attr('data-types'),
    terms: $button.attr('data-terms'),
    action: 'ajax_post_feed_loadmore',
  };

  $.ajax({
    url: php_vars.ajax_url,
    type: "POST",
    dataType: 'html',
    data,
    beforeSend: function () {
      $button.text('Loading...').prop('disabled', true);
    },
    success: function (htmlResponse) {
      if (htmlResponse) {
        $feed.find('.post-feed__items').append(htmlResponse);
      }
    },
    complete: function () {
      $button.text($button.attr('data-label')).prop('disabled', false);
      let currentPage = parseInt($button.attr('data-page')) + 1;
      $button.attr('data-page', currentPage);
      if (currentPage > parseInt($button.attr('data-max-pages'))) {
        $button.hide();
      }
    }
  });
}

export default function initPostFeedFunctions(){
  $doc.on('click', '.js-post-feed-loadmore', function () {
    ajaxLoadMoreFeedPosts($(this));
  });
}
initPostFeedFunctions();
